<template>
  <div>
    <div ref="dcMap" class="cuebiq-chart map text-center" style="margin: auto; float: none;">
    </div>
    <div class="text-center">
      <div class="legend undefined">
        <svg ref="dcMapLegend" class="text-center" :width="legendWidth" height="60">
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import dc from 'dc';

  /* eslint-disable */
  export default {
    name: 'dc-map',
    props: ['initFunc', 'dcGroup', 'width', 'height', 'mapJson', 'dimension', 'crossfilterGroup', 'enableOnInit'],

    data: function() {
      return {
        legendWidth: 410,
        dcMap: null
      }
    },

    mounted: function() {
      var self = this;
      self.initMap();
    },

    computed: {},
    methods: {
      initMap: function() {
        var self = this;

        var dcMap = dc.geoChoroplethChart(self.$refs.dcMap, self.dcGroup);
        self.dcMap = dcMap

        dcMap
          .width(self.width)
          .height(self.height)
          .dimension(self.dimension)
          .group(self.crossfilterGroup)
          .projection(self.getCenterProjection(self.mapJson))
          .overlayGeoJson(self.mapJson.features, "province", function (d) {
            return d.properties.level1;
          });

        var d3Legend = d3.legend.color();

        var enableRender = !self.enableOnInit ? true : typeof self.enableOnInit.render === 'undefined' || self.enableOnInit.render;
        var enableLegend = !self.enableOnInit ? true : typeof self.enableOnInit.legend === 'undefined' || self.enableOnInit.legend;

        if (enableRender) {
          dcMap.render();
        }

        self.initFunc(dcMap, d3Legend, self.getCenterProjection, self.initLegend);

        if (enableLegend) {
          self.initLegend(d3Legend);
        }
      },

      initLegend: function(d3Legend) {
        var self = this;

        d3Legend
          .scale(self.dcMap.colors())
          .orient('horizontal');

        var legendSvg = d3.select(self.$refs.dcMapLegend);

        var legendInnerWidth = d3Legend.shapeWidth() * d3Legend.cells() + 2 * (d3Legend.cells() - 1); // includes the 2 pixel spacing between the cells
        var translateX = (self.legendWidth - legendInnerWidth)/2;

        legendSvg.append("g")
          .attr("class", "legend-g")
          .attr("transform", "translate(" + translateX + ",20)");

        legendSvg.select(".legend-g")
          .call(d3Legend);
      },

      getCenterProjection: function(feature) {
        var self = this;

        var projection = d3.geo.equirectangular()
          .rotate([100, -45])
          .center([5, 20])
          .scale(500)
          .translate([self.width/2, self.height/2])

        var path = d3.geo.path()
            .projection(projection);

        return projection;
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/DcMap.vue